module.exports = __webpack_public_path__ + "img/remainder3.a260ebaa.svg";